import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles, makeStyles } from '@material-ui/styles';
import { genfunction } from 'helpers'
import CancelIcon from '@material-ui/icons/Cancel'
import {
    Card, CardContent, CardHeader, Grid, IconButton,
    Table, TableBody, TableCell, TableRow, Typography
} from '@material-ui/core';
import CouponItems from '../components/CouponItems';
import { actionShopCartResetDonation, actionShopCartRemoveCouponFromMembershiptype } from 'actions';

import { actionDeleteGiftCardHold } from 'actions';
import { actionGetTransactionFee } from 'actions';

const { TransactionFeeProductID, ApplyTransactionFee } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {},
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    labelbold: {
        fontWeight: "bold",
        fontSize: "18px"
    },
    paybutton: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        width: "100%",
        marginTop: "10px"
    },
    spacer: {
        flexGrow: 1
    },
    row: {
        height: '42px',
        display: 'flex',
        alignItems: 'center',
        marginTop: theme.spacing(1)
    },
    center: {
        position: "relative",
        margin: "auto",
        bottom: "70%"
    },
    diplaynone: {
        display: "none"
    },
    textaligncenter: {
        textAlign: "center"
    },
    hidden: {
        visibility: "hidden"
    },
    cashlessvalue: {
        color: theme.palette.error.main
    },
    couponAmount: {
        color: 'red'
    }
}));

const PayableCard = props => {
    const { products, cashless, membershipPackages, gatickets, orderProducts, donationProducts } = props;

    let hasitems = (products && products.length) > 0
        || (membershipPackages && membershipPackages.length > 0)
        || (gatickets && gatickets.length > 0)
        || (orderProducts && orderProducts.length > 0)
        || (donationProducts && donationProducts.length > 0);
    const classes = useStyles();
    const dispatch = useDispatch();

    const donation = useSelector(state => state.reducerShopCart.donation);
    const transactionfee = useSelector(state => state.reducerTransactionFee);
    const giftcards = useSelector(state => state.reducerGiftCards);
    const showTransFee = useSelector(state => state.reducerShopCart.showTransactionFee);


    if (giftcards.giftcards && giftcards.giftcards.length > 0) {
        if (giftcards.giftcards.filter(x => x.AddedToCart === true).length > 0) {
            hasitems = true;
        }
    }

    const removecashlesskhandler = (GiftcardHoldRef) => {
        actionDeleteGiftCardHold(dispatch, GiftcardHoldRef);
    }

    const RemoveDonation = () => {
        actionShopCartResetDonation(dispatch);
    }

    useEffect(() => {
        if (ApplyTransactionFee && TransactionFeeProductID > 0) {
            actionGetTransactionFee(dispatch, TransactionFeeProductID, 'transactionfee');
        }
    }, [])

    const GetMembershipTypeDiscount = (memTypeID) => {
        let filter = membershipPackages[0].MembershipProducts.filter(x => x.MembershipTypeID === memTypeID)[0];
        var totalDiscount = 0;

        if (filter.MembershipType == "AddOn") {
            totalDiscount = filter.CouponCodeIncTax;
        }
        else {
            totalDiscount = filter.Users.length * filter.CouponCodeIncTax;
        }

        return totalDiscount;
    }

    return (
        <Grid>
            <Grid item xs={12}>
                <Card>
                    <CardHeader className={classes.tourheaderbox}
                        title="To Pay"
                        titleTypographyProps={{ color: "inherit" }}
                    />
                    <CardContent>
                        <Grid container>
                            <Grid container item xs={12} className={!hasitems ? classes.hidden : ""} >
                                <Table size="small" className={classes.table} aria-label="spanning table">
                                    <TableBody>

                                        {donation.isdonationApplied ? <TableRow key={donation.price}>
                                            <TableCell className={classes.tablecell} align="left">
                                                <IconButton
                                                    edge="end"
                                                    size="small"
                                                    onClick={() => RemoveDonation()}>
                                                    <CancelIcon color={"error"} />
                                                </IconButton>{'      ' + donation.productName}
                                            </TableCell>
                                            <TableCell align="right">{genfunction.ccyFormat(parseFloat(donation.price))}</TableCell>
                                        </TableRow> : null}

                                        {products.map(product => (
                                            <CouponItems key={product.TourEventID} products={product} membershipPackages={membershipPackages} />
                                        ))}

                                        {gatickets && gatickets.length > 0 ?
                                            <CouponItems key={"GATicket"} gatickets={gatickets} />
                                            : ""}

                                        {donationProducts && donationProducts.length > 0 ?
                                            <CouponItems key={"Donations"} donationProducts={donationProducts} />
                                            : ""}

                                        {giftcards.giftcards && giftcards.giftcards.length > 0 ?
                                            giftcards.giftcards.filter(x => x.CartQty > 0 || (x.MaxPrice !== undefined && x.TotalAmount > 0)).map(gc => (
                                                <CouponItems key={gc.ProductID} giftcards={gc} />
                                            )) : null}

                                        {orderProducts && orderProducts.length > 0 ?
                                            <TableRow key={props.products.TourEventID}>
                                                <TableCell>{"Order"}</TableCell>
                                                <TableCell align="right">{genfunction.ccyFormat(genfunction.getOrderProductsTotalPrice(orderProducts).total)}</TableCell>
                                            </TableRow> : ""}

                                        {membershipPackages && membershipPackages.length > 0 && membershipPackages[0].MembershipProducts ?
                                            <CouponItems key={"MembershipTypes"} MembershipTypes={membershipPackages[0].MembershipProducts} />
                                            : ""}

                                        {membershipPackages && membershipPackages.length > 0 ?
                                            membershipPackages.map(pack => (
                                                pack.MembershipProducts && pack.MembershipProducts.filter(x => x.MembershipType === "Membership" && x.Users && x.Users.length > 0 || x.MembershipType === "AddOn" && x.Quantity > 0)
                                                    .map(memType => (
                                                        <>
                                                            <TableRow key={memType.MembershipTypeID}>
                                                                <TableCell align="left">

                                                                    {'      ' + memType.ProductName}
                                                                </TableCell>
                                                                <TableCell align="right" >{genfunction.ccyFormat((memType.Users !== undefined ? memType.TotalAmount * (memType.Users ? memType.Users.length : 0) : memType.TotalAmount))}</TableCell>
                                                            </TableRow>
                                                            {memType.hasOwnProperty('CouponCodeApplied') && memType.CouponCodeApplied.length > 0 ?
                                                                <TableRow >
                                                                    <TableCell className={classes.tablecell} align="left">
                                                                        <IconButton
                                                                            edge="end"
                                                                            size="small"
                                                                            onClick={() => actionShopCartRemoveCouponFromMembershiptype(dispatch, memType.MembershipTypeID)}>
                                                                            <CancelIcon color={"error"} />
                                                                        </IconButton>{memType.ProductName + '(' + memType.CouponCodeApplied + ")"}
                                                                    </TableCell>
                                                                    {memType.hasOwnProperty('NoFinancialDis') && memType.NoFinancialDis ?
                                                                        <TableCell align="right" className={classes.couponAmount}>Time Extension applied</TableCell>
                                                                        :
                                                                        <TableCell align="right" className={classes.couponAmount}>- {genfunction.ccyFormat(GetMembershipTypeDiscount(memType.MembershipTypeID))}</TableCell>
                                                                    }

                                                                </TableRow>
                                                                : ''}
                                                        </>

                                                    ))
                                            )
                                            ) : null}

                                        {showTransFee && transactionfee.transactionFee[0] && transactionfee.transactionFee[0].Price > 0 && transactionfee.transactionFee !== "nocontent" ? <TableRow key={transactionfee.transactionFee[0].Price}>

                                            <TableCell className={classes.tablecell} align="left">
                                                <IconButton
                                                    edge="end"
                                                    size="small"
                                                    disabled={true}>
                                                </IconButton>{transactionfee.transactionFee[0].ProductName}
                                            </TableCell>
                                            <TableCell align="right">{genfunction.ccyFormat(parseFloat(genfunction.TransactionFee(products, donation, transactionfee.transactionFee[0], cashless, membershipPackages, gatickets, giftcards.giftcards, orderProducts, donationProducts)))}</TableCell>
                                        </TableRow> : null}

                                        {cashless.map(objcashless => (
                                            <TableRow key={objcashless.GiftcardNo}>
                                                <TableCell className={classes.tablecell} align="left">
                                                    <IconButton
                                                        edge="end"
                                                        size="small"
                                                        onClick={() => removecashlesskhandler(objcashless.GiftcardHoldRef)}
                                                    >
                                                        <CancelIcon color={"error"} />
                                                    </IconButton>
                                                    {'      ' + 'Giftcard Applied - ' + genfunction.maskGiftCardNo(objcashless.GiftcardNo)}</TableCell>
                                                <TableCell align="right" className={classes.cashlessvalue}>{'-' + genfunction.ccyFormat(objcashless.HoldAmount)}</TableCell>
                                            </TableRow>
                                        ))}
                                        <TableRow>
                                            <TableCell className={classes.labelbold}>Amount To Pay</TableCell>
                                            <TableCell className={classes.labelbold} align="right">{genfunction.ccyFormat(genfunction.subproducttotal(products, cashless, donation, (showTransFee ? transactionfee.transactionFee[0] : null), membershipPackages, gatickets, giftcards.giftcards, orderProducts, donationProducts))}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </Grid>
                            <div className={classes.center + " " + (hasitems ? classes.diplaynone : "")}>
                                <div className={classes.textaligncenter}>
                                    <Typography display="block" gutterBottom={true} variant="subtitle1" component="p">No item in the cart</Typography>
                                </div>
                            </div>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>

        </Grid>
    );
};

PayableCard.propTypes = {
    products: PropTypes.array.isRequired
};

export default PayableCard;
